
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";

interface DataType {
  preNumbers: number[];
  fixed: boolean;
}
interface PropType {
  num: number;
}
interface MethodType {
  fix(): void;
  shuffle(): number[];
  next(): void;
  nextTime(): number;
}
interface ComputedType {
  displayNum(): number;
}
export default Vue.extend({
  name: "Roulette",
  components: {
  },
  props: {
    num: Number,
  },
  data(): DataType {
    return {
      preNumbers: [],
      fixed: false,
    };
  },
  watch: {
    num(nv) {
      this.fixed = false;
      if (nv) {
        this.preNumbers = this.shuffle(
          Array.from({ length: 75 }, (_, i) => i + 1).filter(v => v !== nv),
        ).slice(0, 40);
        this.next();
      }
    },
  },
  computed: {
    displayNum() {
      const len = this.preNumbers.length;
      return len ? this.preNumbers[len - 1] : this.num;
    },
  },
  methods: {
    fix() {
      this.$emit("onFix", this.num);
    },
    shuffle(array: number[]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    next() {
      this.preNumbers.pop();
      if (this.preNumbers.length > 0) {
        const time = this.nextTime();
        setTimeout(this.next, time);
      } else {
        this.fixed = true;
        this.$emit("fixed", this.num);
      }
    },
    nextTime() {
      const n = this.preNumbers.length;
      if (n < 3) return 500;
      if (n < 5) return 300;
      if (n < 7) return 100;
      if (n < 10) return 50;
      return 20;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, PropType>);

